import { Link } from "react-router-dom";
// Fix E (2026-09-04): entró la identidad oficial de LOCCITEC. El ícono
// Navigation de lucide-react era la marca de relleno; ya no se usa acá.
import { LogotipoLoccitec } from "@/components/marca/LogoLoccitec";
import { RASTREO } from "@/constants/testIds";

export const BrandHeader = ({ compact = false }) => {
  return (
    <header
      data-testid={RASTREO.brandHeader}
      className="w-full border-b border-[var(--tc-border)] bg-white"
    >
      <div className="mx-auto flex max-w-5xl items-center justify-between px-5 py-4">
        {/* Fix E (2026-09-04): el logotipo ya dice "loccitec", así que la segunda
            línea de texto que repetía LOCCITEC se saca por redundante. Queda
            marca + separador + nombre del producto, en una sola línea. */}
        <Link to="/" className="flex items-center gap-3">
          <LogotipoLoccitec className="h-7 w-auto shrink-0" />
          <span className="h-6 w-px shrink-0 bg-[var(--tc-border)]" aria-hidden="true" />
          <span className="text-[15px] font-semibold tracking-tight text-[var(--tc-text)]">
            Torre de Control
          </span>
        </Link>
        {!compact && (
          <span className="hidden text-sm text-[var(--tc-text-secondary)] sm:block">
            Rastreo de unidades
          </span>
        )}
      </div>
    </header>
  );
};
